import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgramViewComponent } from './program-view/program-view.component';
import { ProgramDashboardComponent } from './program-dashboard/program-dashboard.component';
import { RouterModule } from '@angular/router';
import { ProgramRoutes } from './program.routing';
import { ProgramContractsComponent } from './program-contracts/program-contracts.component';
import { SharedModule } from '../shared/shared.module';
import { MatSidenavModule } from '@angular/material';

@NgModule({
  declarations: [ProgramViewComponent, ProgramDashboardComponent, ProgramContractsComponent],
  exports: [ProgramViewComponent, ProgramDashboardComponent, ProgramContractsComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatSidenavModule,
    RouterModule.forChild(ProgramRoutes)
  ]
})
export class ProgramModule { }
